import * as React from "react";
import TopNavigation from "@amzn/awsui-components-react/polaris/top-navigation/1.0-beta";
import { IconProps, SideNavigation, SideNavigationProps } from '@amzn/awsui-components-react';
import { URLS } from '../constants/Constants';
import { Privileges } from "src/utils/UserSitesUtils";
import { debug } from '../utils/commonUtils';

export const TopNav = (
  props:
    {
      setSiteSelectVisibleCallback: Function,
      sitename: string | undefined,
      sitePrivs: Privileges[],
      username: string,
      darkMode: boolean,
      setDarkModeCallback: Function
    }
) => {
  const i18nStrings = {
    searchIconAriaLabel: 'Search',
    searchDismissIconAriaLabel: 'Close search',
    overflowMenuTriggerText: 'More'
  };

  let stage = 'prod';
  console.log(`TopNav() stage is ${stage}`);

  const permissions = () => {

  };

  return (
    <div className="awsui" id="header" style={{position: 'sticky', top: 0, zIndex: 1002}}>
      <TopNavigation
        i18nStrings={i18nStrings}
        identity={{
          href: '#',
          title: `Silencio${stage.toLowerCase() !== 'prod' ? `-${stage.toUpperCase()}` : ''} ${props.sitename ? '(' + props.sitename + ')' : ''}`,
          logo: {
            src: 'data:image/svg+xml;base64,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',
            alt: 'Silencio'
          }
        }}
        utilities={[
          {
            type: 'button',
            text: `${props.sitename ? props.sitename + ' - Change Site' : 'Select Site'}`,
            iconName: 'edit',
            ariaLabel: 'Change Site',
            href: '#/SelectSite',
            badge: false,
            disableUtilityCollapse: true,
            onClick: () => {props.setSiteSelectVisibleCallback(true)}
          },
          {
            type: 'button',
            text: `Permissions:
              ${
                props.sitePrivs === undefined
                  ? 'checking...'
                  :
                props.sitePrivs?.length > 0
                  ? props.sitePrivs?.map(sp => `${sp }`)
                  : 'None'
              }`,
            iconName: props.sitePrivs === undefined ? 'status-pending' as IconProps.Name : 'key' as IconProps.Name, 
            ariaLabel: 'Site Permissions',
            badge: props.sitePrivs?.length > 0 ? false : true,
            disableUtilityCollapse: true
          },
          {
            type: 'menu-dropdown',
            text: 'Help',
            items: [
              {
                id: "bug",
                text: "Report an Issue",
                href: URLS.ReportABug,
                external: true,
                externalIconAriaLabel: " (opens in new tab)"
              },
              {
                id: "feature",
                text: "Request a Feature",
                href: URLS.FeatureRequest,
                external: true,
                externalIconAriaLabel: " (opens in new tab)"
              },
              {
                id: "guide",
                text: "User Guide",
                href: URLS.UserGuide,
                external: true,
                externalIconAriaLabel: " (opens in new tab)"
              },
              {
                id: "hub",
                text: "Guardian Hub",
                href: URLS.GuardianHub,
                external: true,
                externalIconAriaLabel: " (opens in new tab)"
              },
            ]
          },
          {
            type: 'button',
            iconName: props.darkMode ? 'angle-down' as IconProps.Name : 'angle-up' as IconProps.Name, 
            text: `${props.darkMode ? 'Dark Mode' : 'Light Mode'}`,
            onClick: () => {props.setDarkModeCallback(!props.darkMode)},
          },
          {
            type: 'button',
            text: props.username,
            iconName: 'user-profile'
          }
        ]}
      />
    </div>
  );
}

export const SideNav = (props: any) => {

  const home = { text: `Welcome to Silencio ${props.username}`, href: '#/' };

  const [activeHref, setActiveHref] = React.useState('#/SiteDevices');
  const [setContent] = React.useState<any>();
    
  const navItems: SideNavigationProps.Item[] = [
    {
      type: "link",
      text: "Select Site",
      href: "#/SelectSite"
    },
  ];

  const onFollowHandler = (event: any) => {
    debug(`onFollowHandler(): event is ${JSON.stringify(event)}`);
    const href = event.detail.href;
    switch(href) {
      case '#/SelectSite':
        debug(`onFollowHandler(): calling props.setSiteSelectVisibleCallback()`);
        props.setSiteSelectVisibleCallback(true);
        break;
      case '#/Inputs':
        props.setDeviceTypeCallback('inputs');
        break;
      case '#/Panels':
        props.setDeviceTypeCallback('panels');
        break;
      case '#/Readers':
        props.setDeviceTypeCallback('readers');
        break;
    }
    if (href !== '#/SelectSite') setActiveHref(href);
  };

  return(
    <SideNavigation
      header={props.home}
      items={navItems}
      activeHref={activeHref}
      onFollow={(event: any) => onFollowHandler(event)}
    />
  );
}
